// @flow

import styled from "@emotion/styled";

import { Small } from "src/styles/modal";
import { SecondaryFooter } from "src/styles/form";

import * as colors from "src/styles/constants/colors";

export const StyledModal = styled(Small)``;

export const InfoMessage = styled.div`
  font-size: 16px;
  padding: 1.5em;
`;

export const Buttons = styled(SecondaryFooter)`
  > button:nth-of-type(2) {
    background: ${colors.danger};
    border-color: transparent;
    width: 69px;
  }
`;
